import React from 'react'

export const withInfiniteScroll = (conditionFn) => (Component) =>
    class WithInfiniteScroll extends React.Component {

        componentDidMount() {
            const { containerRef } = this.props;
            if (containerRef) {
                containerRef.addEventListener('scroll', this.onScroll, false);
            }
        }

        componentDidUpdate(prevProps) {
            const { containerRef } = this.props;
            if (prevProps.containerRef !== containerRef) {
                prevProps.containerRef.removeEventListener('scroll', this.onScroll);
                containerRef.addEventListener('scroll', this.onScroll, false);
            }
        }

        componentWillUnmount() {
            this.props.containerRef.removeEventListener('scroll', this.onScroll, false);
        }

        onScroll = () =>
            conditionFn(this.props) && this.props.onPaginatedFetch();

        render() {
            return <Component {...this.props} />;
        }
    }


// WEBPACK FOOTER //
// ./src/components/hocs/withInfiniteScroll.js